module.exports = __webpack_public_path__ + "static/smart_city-015fb80bf7e08c51988f74c6e7320988.jpg";